module.exports = __webpack_public_path__ + "static/media/bg-opening4534d53474b17b92304f035ad48126ae.webp";